export default __webpack_public_path__ + "static/media/socket-wrench.38a74572.svg";